import { useState, useEffect } from 'react';
import { useUIStore } from '../../stores/uiStore';
import { useUserStore } from '../../stores/userStore';

export default function NicknameModal() {
  const { isNicknameModalOpen, closeNicknameModal } = useUIStore();
  const { register, nickname } = useUserStore();
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isNicknameModalOpen) {
      setName(nickname || '');
    }
  }, [isNicknameModalOpen, nickname]);

  if (!isNicknameModalOpen) return null;

  const handleSubmit = async () => {
    const trimmed = name.trim();
    if (!trimmed || trimmed.length > 12) return;
    setLoading(true);
    setError('');
    try {
      await register(trimmed);
      closeNicknameModal();
    } catch (e: any) {
      setError(e?.message || '注册失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleSubmit();
  };

  return (
    <div className="modal-overlay show" onClick={() => closeNicknameModal(true)}>
      <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
        <h3>取个霸气名号</h3>
        <p className="hint">起个昵称，让全站饲养员记住你</p>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="如：超级飞侠爸"
          maxLength={12}
          autoComplete="off"
          autoFocus
        />
        {error ? (
          <p style={{ color: 'var(--color-wrong)', fontSize: '0.875rem', marginTop: 'var(--space-sm)', textAlign: 'center' }}>
            {error}
          </p>
        ) : null}
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={loading || !name.trim()}
          style={{ marginTop: 'var(--space-md)', width: '100%' }}
        >
          {loading ? '处理中...' : '确认，开冲！'}
        </button>
      </div>
    </div>
  );
}
